(function () {
  'use strict';
  function init() {
    var banner = document.querySelector('[data-mm-cookie-consent]');
    if (!banner || banner.getAttribute('data-mm-cookie-initialized') === '2.0.0') return;
    banner.setAttribute('data-mm-cookie-initialized', '2.0.0');
    var root = document.documentElement;
    var accept = banner.querySelector('[data-mm-cookie-accept]');
    var necessary = banner.querySelector('[data-mm-cookie-necessary]');
    var manage = banner.querySelector('[data-mm-cookie-manage]');
    var close = banner.querySelector('[data-mm-cookie-close]');
    var retry = banner.querySelector('[data-mm-cookie-retry]');
    var form = banner.querySelector('[data-mm-cookie-form]');
    var status = banner.querySelector('[data-mm-cookie-status]');
    var openers = Array.prototype.slice.call(document.querySelectorAll('[data-mm-cookie-open]'));
    var keys = ['preferences', 'analytics', 'marketing'];
    var loading = false, saving = false, ready = false, manual = false;
    var returnFocus = null, loadSerial = 0, saveSerial = 0;
    var loadTimer = null, saveTimer = null;
    var saveControls = Array.prototype.slice.call(banner.querySelectorAll('[data-mm-cookie-accept], [data-mm-cookie-necessary], [data-mm-cookie-form] button, [data-mm-cookie-form] input[name]'));
    function message(kind, fallback) { return banner.getAttribute('data-mm-cookie-' + kind) || fallback; }
    function setStatus(text) { if (status) status.textContent = text || ''; }
    function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
    function usable(api) {
      return !!(api && typeof api.currentVisitorConsent === 'function' && typeof api.setTrackingConsent === 'function');
    }
    function readChoices() {
      try { var api = privacy(); return usable(api) ? api.currentVisitorConsent() : null; }
      catch (_) { return null; }
    }
    function syncInset() {
      if (banner.hidden) { root.style.removeProperty('--mm-cookie-consent-height'); return; }
      var height = Math.ceil(banner.getBoundingClientRect().height);
      if (height > 0) root.style.setProperty('--mm-cookie-consent-height', height + 'px');
    }
    function focusElement(element) {
      if (!element || typeof element.focus !== 'function') return;
      try { element.focus({preventScroll: true}); } catch (_) { element.focus(); }
    }
    function restoreFocus() {
      var target = returnFocus && returnFocus.isConnected && returnFocus !== document.body ? returnFocus : document.querySelector('#MainContent');
      focusElement(target);
    }
    function setFormOpen(open, focus) {
      if (!form) return;
      form.hidden = !open;
      if (manage) manage.setAttribute('aria-expanded', String(open));
      if (focus) focusElement(open ? form.querySelector('input[name]:not([disabled])') : manage);
      window.requestAnimationFrame(syncInset);
    }
    function setOpen(open) {
      var hadFocus = banner.contains(document.activeElement);
      banner.hidden = !open;
      root.classList.toggle('mm-cookie-open', open);
      openers.forEach(function (button) { button.setAttribute('aria-expanded', String(open)); });
      if (close) close.hidden = !open || !manual;
      if (open) window.requestAnimationFrame(syncInset);
      else {
        root.style.removeProperty('--mm-cookie-consent-height');
        setFormOpen(false, false);
        if (hadFocus) restoreFocus();
        manual = false;
      }
    }
    function busy() {
      banner.setAttribute('aria-busy', String(loading || saving));
      saveControls.forEach(function (control) { control.disabled = !ready || loading || saving; });
      if (manage) manage.disabled = !ready || loading || saving;
      if (close) close.disabled = saving;
      if (retry) retry.disabled = loading || saving;
    }
    function prefill(choices) {
      if (!choices || !form) return;
      keys.forEach(function (key) { if (form.elements[key]) form.elements[key].checked = choices[key] === 'yes'; });
    }
    function requiredBanner(choices) {
      var required = false;
      try { var api = privacy(); required = !!(api && typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()); }
      catch (_) { /* Unanswered choices still keep their existing explicit-choice behavior. */ }
      var unanswered = choices && keys.every(function (key) { return choices[key] === ''; });
      return required || !!unanswered;
    }
    function refresh() {
      var choices = readChoices();
      ready = usable(privacy()) && !!choices;
      busy();
      if (!ready) return false;
      if (retry) retry.hidden = true;
      prefill(choices);
      setStatus('');
      if (manual) {
        setOpen(true);
        setFormOpen(true, true);
      } else if (requiredBanner(choices)) {
        if (banner.hidden) returnFocus = document.activeElement;
        setOpen(true);
      } else setOpen(false);
      return true;
    }
    function loadFailed() {
      ready = false; loading = false; busy();
      if (retry) retry.hidden = false;
      setStatus(message('unavailable', 'Cookie settings could not load. Please retry. No changes have been saved.'));
      if (manual) { setOpen(true); focusElement(retry); }
    }
    function loadApi() {
      if (loading || saving) return;
      if (refresh()) return;
      var shopify = window.Shopify;
      if (!shopify || typeof shopify.loadFeatures !== 'function') { loadFailed(); return; }
      loading = true; busy();
      var serial = ++loadSerial;
      loadTimer = window.setTimeout(function () {
        if (serial !== loadSerial) return;
        loadSerial += 1; loadTimer = null; loadFailed();
      }, 8000);
      try {
        shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
          if (serial !== loadSerial) return;
          window.clearTimeout(loadTimer); loadTimer = null; loadSerial += 1; loading = false;
          if (error || !refresh()) loadFailed();
        });
      } catch (_) {
        window.clearTimeout(loadTimer); loadTimer = null; loadSerial += 1; loadFailed();
      }
    }
    function saveFailed() {
      saving = false; busy();
      setStatus(message('error', 'We could not confirm your choices were saved. Review your selection and try again.'));
    }
    function apply(choices) {
      if (loading || saving) return;
      var api = privacy();
      // A failed API load never queues consent to be applied automatically later.
      if (!usable(api) || !readChoices()) { ready = false; loadFailed(); return; }
      var proposed = {};
      keys.forEach(function (key) { proposed[key] = choices[key] === true; });
      var shouldRestoreFocus = banner.contains(document.activeElement);
      saving = true; busy();
      setStatus(message('saving', 'Saving your choices…'));
      var serial = ++saveSerial;
      saveTimer = window.setTimeout(function () {
        if (serial !== saveSerial) return;
        saveSerial += 1; saveTimer = null; saveFailed();
      }, 8000);
      try {
        api.setTrackingConsent(proposed, function (result) {
          if (serial !== saveSerial) return;
          window.clearTimeout(saveTimer); saveTimer = null; saveSerial += 1;
          if (result && result.error) { saveFailed(); return; }
          var current = readChoices();
          var confirmed = current && keys.every(function (key) { return current[key] === (proposed[key] ? 'yes' : 'no'); });
          if (!confirmed) { saveFailed(); return; }
          saving = false; busy(); prefill(current); setStatus(''); setOpen(false);
          if (shouldRestoreFocus) restoreFocus();
          document.dispatchEvent(new CustomEvent('mm:cookie-consent-changed', {detail: proposed}));
        });
      } catch (_) {
        window.clearTimeout(saveTimer); saveTimer = null; saveSerial += 1; saveFailed();
      }
    }
    openers.forEach(function (button) {
      button.hidden = false;
      button.addEventListener('click', function () {
        if (saving) return;
        manual = true; returnFocus = button;
        setOpen(true); setStatus('');
        if (loading) focusElement(banner);
        else loadApi();
      });
    });
    if (accept) accept.addEventListener('click', function () { apply({preferences: true, analytics: true, marketing: true}); });
    if (necessary) necessary.addEventListener('click', function () { apply({preferences: false, analytics: false, marketing: false}); });
    if (manage) manage.addEventListener('click', function () { if (!loading && !saving && ready) setFormOpen(form && form.hidden, true); });
    if (close) close.addEventListener('click', function () { if (manual && !saving) setOpen(false); });
    if (retry) retry.addEventListener('click', loadApi);
    if (form) form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply({preferences: !!form.elements.preferences.checked, analytics: !!form.elements.analytics.checked, marketing: !!form.elements.marketing.checked});
    });
    banner.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && manual && !saving) { event.preventDefault(); setOpen(false); }
    });
    document.addEventListener('visitorConsentCollected', function () {
      if (saving || loading) return;
      // Read the API, not event-supplied consent, and never submit a response for the visitor.
      refresh();
    });
    window.addEventListener('resize', syncInset, {passive: true});
    if (window.visualViewport) window.visualViewport.addEventListener('resize', syncInset, {passive: true});
    if ('ResizeObserver' in window) new ResizeObserver(syncInset).observe(banner);
    window.addEventListener('pageshow', function () { if (!loading && !saving) refresh(); syncInset(); });
    busy(); loadApi();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
}());
